import Icon from "../../../../Elements/Icon/Icon";
import Image from "components/Elements/Image/Image";
import ReviewComponent from "./ReviewComponent";
import Form from "components/Reusable/Form/Form";
import Button from "components/Elements/Button/Button";
import pickerFormFields from "./pickerFormFields";
import useGetStartedLoginCallback from "../../helpers/useGetStartedLoginCallback";
import { useContent } from "contexts/contentContext/contentContext";
import { useUser } from "../../../../../contexts/userContext/userContext";
import { useToasts } from "react-toast-notifications";
import { useState } from "react";

import generalStyles from "../../styles.module.scss";
import styles from "./styles.module.scss";

const DEFAULT_MESSAGE =
  "This is the default message. The user asked to contact him on the marketing Picker page";

const FifthSection = () => {
  const { getTextByKey, getHtmlByKey, getDirection, getLanguageCulture } =
    useContent();
  const { contactUs, getUserData } = useUser();
  const { addToast } = useToasts();
  const handleClick = useGetStartedLoginCallback();
  const [isSuccess, setIsSuccess] = useState(false);

  const handleSubmit = async (values: any) => {
    const body = {
      ...values,
      ContactEmail: values.Email,
      ContactMessage: DEFAULT_MESSAGE,
      ContactPage: "jumbo-picker",
      ContactPhone: values.ContactPhone,
      ContactSender: values.FullName,
      ContactTitle: "Picker",
      ContactCulture: getLanguageCulture().split("-")[0],
      Culture: getLanguageCulture().toLowerCase(),
      MailType: "ContactUsPicker",
      userIp: getUserData().User_IP,
      platform: getUserData().User_Platform,
    };
    const res = await contactUs(body);
    if (res.status === "success") {
      addToast(getTextByKey("contact-support-success"), {
        appearance: "success",
      });
      setIsSuccess(true);
    } else {
      addToast(getTextByKey("contact-support-fail"), {
        appearance: "error",
      });
    }
  };

  const direction = getDirection();

  return (
    <>
      <div className={styles.section}>
        <Image
          name="picker/picker-icon"
          className={styles.titleImage}
          ext="png"
        />
        <h3 className={generalStyles.titleDark}>
          {getTextByKey("picker-section-5-title-first")}
        </h3>
        <p className={generalStyles.textDark}>
          {getHtmlByKey("picker-section-5-text-first")}
        </p>
        <ReviewComponent />
        <Button
          children={undefined}
          buttonClass={styles.button}
          title={getTextByKey("get-started")}
          onClick={handleClick}
        />
        <div className={styles.bgFlareViolet}></div>
        <Image
          name="cloud"
          ext="png"
          className={`${styles.cloud} ${
            direction === "rtl" ? `${styles.rtl}` : ""
          }`}
        />
      </div>
      <div className={styles.formSection}>
        <h3>{getTextByKey("contact-us-picker-title")}</h3>
        {!isSuccess ? (
          <Form
            // @ts-ignore
            fields={pickerFormFields}
            onSubmit={handleSubmit}
            submitProps={{
              title: getTextByKey("submit"),
            }}
            fieldsProps={{
              label: "hidden",
            }}
            // captchaProvider="cloudflare"
            // cloudflareActionName="contactUs"
          />
        ) : (
          <div className={styles.supportSuccess}>
            <div className="icon-success">
              <Icon name="check" ext="svg" pink xxxl />
            </div>
            <span>{getTextByKey("contact-support-success")}</span>
          </div>
        )}
        <div className={styles.readMoreSection}>
          <Icon name="portfolio" xxl blue />
          <span>{getHtmlByKey("read-more-for-biz")}</span>
        </div>
      </div>
    </>
  );
};

export default FifthSection;
